export default __webpack_public_path__ + "static/media/cloud-3-day.4196961f.svg";